import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBG7ZkPRNaEKQqt-MhXjyDMsXakQK3qqfY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "pureple-prod.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://pureple-prod.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "pureple-prod",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "pureple-prod.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "157249670803",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:157249670803:web:4d4ac1e5de94a60bdd4766",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-YMDXQEX7XP",
};

// Debug logging to check configuration
console.log("Firebase Config:", firebaseConfig);

export default initializeApp(firebaseConfig);
